import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const pricesManagementReducer = foxGridReducer(gridNames.pricesManagement);

export default pricesManagementReducer;
